// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hvj3p","hidden":"styles_hidden__-NXJk"};